import { createFileRoute } from "@tanstack/react-router"

import TabsLayout from "@/components/common/TabsLayout/TabsLayout"

const tabs = [
  {
    id: "price-change",
    label: "Price Change",
    path: `/app/pricing/price-change`,
  },
  {
    id: "price-change-history",
    label: "Price Change History",
    path: `/app/pricing/history-price-change`,
  },
]

export const Route = createFileRoute("/app/pricing/_layout")({
  component: SystemAdminLayout,
})

function SystemAdminLayout() {
  return <TabsLayout title='Pricing' tabs={tabs} />
}
